$(document).ready(function() {

  var CUSTOMER_PERSON_TYPE = 'customer_person_type_id';
  var CHANGE_PERSON_TYPE = 'change-person-type';

  var DIV_WITH_PERSON_TYPE_PHYSICAL = 'div_with_person_type_physical';
  var DIV_WITH_PERSON_TYPE_JURIDICAL = 'div_with_person_type_juridical';
  var DIV_WITH_PERSON_TYPE_JURIDICAL_CONTACTS = 'div_with_person_type_juridical_contacts';
  
  $(document).on('click', '.' + CHANGE_PERSON_TYPE, function(){
    hideElement(DIV_WITH_PERSON_TYPE_PHYSICAL, true);
    hideElement(DIV_WITH_PERSON_TYPE_JURIDICAL, true);
    hideElement(DIV_WITH_PERSON_TYPE_JURIDICAL_CONTACTS, true);

    if(this.value == 1){
      hideElement(DIV_WITH_PERSON_TYPE_PHYSICAL, false);
    } else if(this.value == 2){
      hideElement(DIV_WITH_PERSON_TYPE_JURIDICAL, false);
      hideElement(DIV_WITH_PERSON_TYPE_JURIDICAL_CONTACTS, false);
    } 
  });

});
